module.exports = __webpack_public_path__ + "img/logo-hubdoc.efbffb89.svg";